import api from './api';

export type NotificationPreferences = {
  email_enabled: boolean; email_task: boolean; email_leave: boolean; email_planner: boolean;
  // Attendance = your own late-coming warning, and (for managers) the alert
  // when someone reporting to you comes in late.
  email_attendance: boolean;
  push_enabled: boolean; push_task: boolean; push_leave: boolean; push_planner: boolean;
  push_attendance: boolean;
};

export const getMyNotificationPreferences = async (): Promise<NotificationPreferences> => {
  // Load call — callers fall back silently to defaults on failure (no error toast).
  const res = await api.get('/notifications/my-preferences');
  return res.data.preferences;
};

export const updateMyNotificationPreferences = async (
  payload: Partial<NotificationPreferences>,
): Promise<NotificationPreferences> => {
  try {
    const res = await api.put('/notifications/my-preferences', payload);
    return res.data.preferences;
  } catch (e: any) {
    throw new Error(e?.response?.data?.detail || e?.message || 'Could not save preferences');
  }
};
